import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import RswState from "../../enums/robot/rsw/rsw-state";

const statusLightBackgroundTemplate = "rgba({colorCode},0.6)";

const useStyles = makeStyles()((_) => ({
  statusLight: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: "1px solid rgba(0,0,0,0.1)",
  },
}));

export enum StatusLightColor {
  Green = "144, 238, 144",
  Yellow = "255, 239, 130",
  Red = "255, 160, 160",
  Grey = "200, 200, 200",
  Orange = "255, 200, 150",
  White = "240, 240, 240",
  LightBlue = "190, 220, 255",
}

export const getRswStateStatusLightColor = (state: RswState | null) => {
  if (state === null) {
    return StatusLightColor.White;
  }

  switch (state) {
    case RswState.Homing:
    case RswState.Navigate:
    case RswState.Scheduled:
    case RswState.FleetControlActive:
      return StatusLightColor.Green;
    case RswState.Restart:
    case RswState.RestartSimulation:
    case RswState.Waiting:
    case RswState.RemoteControl:
    case RswState.Commissioning:
      return StatusLightColor.Yellow;
    case RswState.Updating:
      return StatusLightColor.LightBlue;
    case RswState.ErrorBaseboard:
    case RswState.ErrorBatteryCellImbalance:
    case RswState.ErrorCamera:
    case RswState.ErrorDatabase:
    case RswState.ErrorDiskFull:
    case RswState.ErrorEmergencyStop:
    case RswState.ErrorEmergencyEvacuation:
    case RswState.ErrorLidar:
    case RswState.ErrorNode:
    case RswState.ErrorSystem:
    case RswState.ErrorIMU:
      return StatusLightColor.Red;
    case RswState.MaintenanceBatteryDeep:
    case RswState.MaintenanceBrushFront:
    case RswState.MaintenanceBrushRoller:
    case RswState.MaintenanceDropped:
    case RswState.MaintenanceEnvironmentHazard:
    case RswState.MaintenanceFilterLifetime:
    case RswState.MaintenanceFilterCleaner:
    case RswState.MaintenanceScheduled:
    case RswState.MaintenanceKidnapped:
    case RswState.MaintenanceLoadMap:
    case RswState.MaintenanceNavigation:
    case RswState.MaintenanceNoStationDetectedWithCamera:
    case RswState.MaintenanceNoStationDetectedWithLidar:
    case RswState.MaintenanceNoStationDetectedWithLidarAndCamera:
    case RswState.MaintenancePositionLost:
    case RswState.MaintenanceUnknownRoom:
    case RswState.MaintenanceWrongRoom:
    case RswState.MaintenanceWrongFloor:
    case RswState.MaintenanceDirtBinFull:
    case RswState.MaintenanceNavigationNoStation:
    case RswState.MaintenanceNavigationAllZonesFailed:
    case RswState.MaintenanceNavigationNoRoom:
    case RswState.MaintenanceNavigationNoPath:
    case RswState.MaintenanceNavigationNotCharging:
    case RswState.MaintenanceNavigationDemoAreaTooSmall:
    case RswState.MaintenanceNavigationCollision:
    case RswState.MaintenanceNavigationNotAllowedInFreeSpace:
    case RswState.MaintenanceTooMuchWheelSlippage:
    case RswState.MaintenanceNavigationGateUnresponsive:
      return StatusLightColor.Orange;
    case RswState.InitSystem:
    case RswState.InitSystemSimulation:
    case RswState.Standby:
    case RswState.StandbySimulation:
    case RswState.InitMap:
    case RswState.FleetControlStandby:
      return StatusLightColor.Grey;
    case RswState.Ready:
    case RswState.Idle:
      return StatusLightColor.White;
    default:
      return StatusLightColor.White;
  }
};

const StatusLight: React.FC<{ color: StatusLightColor }> = ({ color }) => {
  const { classes } = useStyles();

  let statusLightBackground: string | null = null;
  if (color != null) {
    statusLightBackground = statusLightBackgroundTemplate.replaceAll("{colorCode}", color);
  }

  return (
    <Box sx={{ width: "25px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className={classes.statusLight} style={{ background: statusLightBackground ?? "" }} />
    </Box>
  );
};

export default StatusLight;
